<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div class="lightbox">
      <div>
        <div id="SliderTop">
          <i class="fas fa-2x fa-chevron-up toTop-arrow"></i>
        </div>

        <h1>{{ days }} Day Client Registration</h1>
        <p class="my-3">&nbsp;</p>

        <div class="PcDevice">
          <table class="table">
            <thead class="thead-dark text-center">
              <tr>
                <th scope="col">No.</th>
                <th scope="col">Email</th>
                <th scope="col">Application Date</th>
                <th scope="col">Registration Status</th>
                <th scope="col">Used Date</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, key) in inviteList" :key="item.No" class="text-center">
                <th scope="row">{{ item.No }}</th>
                <td>{{ item.ClientEmail }}</td>
                <td>{{ item.CreateTime }}</td>
                <td v-if="item.ClientStatus == '未登錄' || item.ClientStatus == 'Incomplete'" class="text-danger">
                  {{ item.ClientStatus }}
                </td>
                <td v-else class="text-success">
                  {{ item.ClientStatus }}
                </td>
                <td>{{ item.UsedTime }}</td>
              </tr>
            </tbody>
          </table>
          <div v-if="totalPage > 1" class="pt-3 d-flex justify-content-center">
            <nav>
              <ul class="pagination">
                <li v-if="totaltenPageNum > 1" class="page-item" :class="{ disabled: tenPageNum == 0 }">
                  <a class="page-link" href="#" title="Last ten pages" aria-label="Previous" @click="returntenPage()">
                    <span aria-hidden="true"><i class="fas fa-angle-double-left"></i></span>
                  </a>
                </li>
                <li class="page-item" :class="{ disabled: currentPage == 1 }">
                  <a class="page-link" href="#" title="Last page" aria-label="Previous" @click="lastPage()">
                    <span aria-hidden="true"> <i class="fas fa-angle-left"></i> </span>
                  </a>
                </li>
                <li class="page-item" v-for="page in showpage" :key="page" :class="{ active: currentPage == page }">
                  <a class="page-link" href="#" @click="getPage(page)">{{ page }}</a>
                </li>
                <li class="page-item" :class="{ disabled: currentPage == totalPage }">
                  <a class="page-link" href="#" title="Next page" aria-label="Next" @click="nextPage()">
                    <span aria-hidden="true"><i class="fas fa-angle-right"></i></span>
                  </a>
                </li>
                <li
                  v-if="totaltenPageNum > 1"
                  class="page-item"
                  :class="{ disabled: tenPageNum == totaltenPageNum - 1 }"
                >
                  <a class="page-link" href="#" title="Next ten pages" aria-label="Next" @click="nexttenPage()">
                    <span aria-hidden="true"><i class="fas fa-angle-double-right"></i></span>
                  </a>
                </li>
              </ul>
              <p class="text-center mt-2">{{ currentPage }} of {{ totalPage }}</p>
            </nav>
          </div>
        </div>
        <div class="MbDevice">
          <div class="row">
            <div class="col-sm-3 mb-2" v-for="(item, index) in inviteList" :key="index">
              <div class="card mt-3">
                <div class="card-body">
                  <div class="card-header" style="font-weight: bold">No. {{ item.No }}</div>
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item">
                      <div><span class="font-weight-bold">Email :</span> {{ item.ClientEmail }}</div>
                    </li>
                    <li class="list-group-item">
                      <div><span class="font-weight-bold">Application Date :</span> {{ item.CreateTime }}</div>
                    </li>
                    <li
                      class="list-group-item"
                      v-if="item.ClientStatus == '未登錄' || item.ClientStatus == 'Incomplete'"
                    >
                      <span class="font-weight-bold">Registration Status :</span>
                      <span class="text-danger">{{ item.ClientStatus }}</span>
                    </li>

                    <li class="list-group-item" v-else>
                      <span class="font-weight-bold">Registration Status :</span>
                      <span class="text-success">{{ item.ClientStatus }}</span>
                    </li>
                    <li class="list-group-item">
                      <span class="font-weight-bold">Used Date : </span>{{ item.UsedTime }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div v-if="totalPage > 1" class="pt-3 d-flex justify-content-center">
            <nav>
              <ul class="pagination pagination-sm">
                <li v-if="totaltenPageNum > 1" class="page-item" :class="{ disabled: tenPageNum == 0 }">
                  <a class="page-link" href="#" title="切換前十頁" aria-label="Previous" @click="returntenPage()">
                    <span aria-hidden="true"><i class="fas fa-angle-double-left"></i></span>
                  </a>
                </li>
                <li class="page-item" :class="{ disabled: currentPage == 1 }">
                  <a class="page-link" href="#" title="上一頁" aria-label="Previous" @click="lastPage()">
                    <span aria-hidden="true"> <i class="fas fa-angle-left"></i> </span>
                  </a>
                </li>
                <li class="page-item" v-for="page in showpage" :key="page" :class="{ active: currentPage == page }">
                  <a class="page-link" href="#" @click="getPage(page)">{{ page }}</a>
                </li>

                <li class="page-item" :class="{ disabled: currentPage == totalPage }">
                  <a class="page-link" href="#" title="下一頁" aria-label="Next" @click="nextPage()">
                    <span aria-hidden="true"><i class="fas fa-angle-right"></i></span>
                  </a>
                </li>
                <li
                  v-if="totaltenPageNum > 1"
                  class="page-item"
                  :class="{ disabled: tenPageNum == totaltenPageNum - 1 }"
                >
                  <a class="page-link" href="#" title="切換下十頁" aria-label="Next" @click="nexttenPage()">
                    <span aria-hidden="true"><i class="fas fa-angle-double-right"></i></span>
                  </a>
                </li>
              </ul>
              <p class="text-center mt-2">{{ currentPage }} of {{ totalPage }}</p>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import axios from 'axios'

  export default {
    data() {
      return {
        RegNo: '',
        CSRF_Token: '',
        days: 0,
        currentPage: 1,
        inviteList: [],
        totalPage: '',
        totalNo: '',
        inviteRawData: [],
        totaltenPageNum: 0,
        tenPageNum: 0,
        showpage: [],
        show: true,
        lang: 'en',
      }
    },

    methods: {
      getPage(page) {
        const vm = this
        vm.currentPage = page
        vm.newPageApi()
      },

      nextPage() {
        const vm = this

        vm.currentPage = Number(vm.currentPage) + 1
        vm.newPageApi()
      },

      lastPage() {
        const vm = this
        vm.currentPage = Number(vm.currentPage) - 1
        vm.newPageApi()
      },

      nexttenPage() {
        const vm = this
        vm.tenPageNum = vm.tenPageNum + 1
        vm.showpage = vm.inviteRawData[vm.tenPageNum]
        vm.currentPage = vm.showpage[0]
        vm.newPageApi()
      },

      returntenPage() {
        const vm = this
        vm.tenPageNum = vm.tenPageNum - 1
        vm.showpage = vm.inviteRawData[vm.tenPageNum]
        vm.currentPage = vm.showpage[0]
        vm.newPageApi()
      },

      mainPageApi() {
        const vm = this

        let url = `/apiExhibitors/ClientInvitation/${vm.RegNo}?Page=${vm.currentPage}&type=${vm.days}&Lang=${vm.lang}`

        axios.get(url).then(function (response) {
          // console.log(response)
          if (response.data.pagetotal > 0) {
            vm.inviteList = response.data.Data
            vm.totalPage = response.data.pagetotal
            vm.totalNo = response.data.datatotal

            for (let i = 0; i < vm.totalPage; i++) {
              if (i % 10 === 0) {
                vm.inviteRawData.push([])
              }

              const page = parseInt(i / 10) //parseInt整數公式
              vm.inviteRawData[page].push(i + 1)
            }

            //totaltenPageNum 取得共有幾筆十頁
            vm.totaltenPageNum = vm.inviteRawData.length
            //從取得的筆數後，tenNum 計算出現第幾個十頁數

            let anaNowPage = vm.currentPage - 1 //判定第幾頁(十頁)，頁數減一避免進位

            vm.tenPageNum = parseInt(anaNowPage / 10)
            vm.showpage = vm.inviteRawData[vm.tenPageNum]

            // console.log(vm.currentPage)
            vm.show = true
          } else {
            vm.show = false
          }
        })
      },

      newPageApi() {
        const vm = this

        let url = `/apiExhibitors/ClientInvitation/${vm.RegNo}?Page=${vm.currentPage}&type=${vm.days}&Lang=${vm.lang}`

        axios.get(url).then(function (response) {
          // console.log(response)

          vm.inviteList = response.data.Data

          let anaNowPage = vm.currentPage - 1 //判定第幾頁(十頁)，頁數減一避免進位

          vm.tenPageNum = parseInt(anaNowPage / 10)
          vm.showpage = vm.inviteRawData[vm.tenPageNum]
        })
      },
    },

    created() {
      const vm = this

      //取得語系

      $(() => {
        $('#SliderTop').click(() => {
          $('html,body').animate({ scrollTop: 0 }, 'slow')
          return false
        })

        $(window)
          .scroll(function () {
            if ($(this).scrollTop() > 300) {
              $('#SliderTop').fadeIn(222)
            } else {
              $('#SliderTop').stop().fadeOut(222)
            }
          })
          .scroll()
      })

      //CSRF_Token
      axios.get('https://www.chanchao.com.tw/apiExhibitors/CSRF_Token').then((response) => {
        vm.CSRF_Token = response.data
      })

      //url取出展碼
      let currentUrl = location.href
      vm.RegNo = currentUrl.split('no=')[1].split('&')[0]
      vm.days = currentUrl.split('d=')[1]

      //取天數

      vm.mainPageApi()
    },
  }
</script>

<style lang="scss">
  body {
    background-color: rgb(255, 255, 255);
  }

  .list-group-item {
    padding: 0.4rem 0.8rem;
  }

  .card-body {
    padding: 0.5rem;
  }

  .card-header {
    padding: 0.35rem 0.8rem;
    margin-bottom: 0;
    background-color: #e9eef4;
    border-bottom: 0px;
  }
</style>
